import React from "react";
import LogView from "../../Dashboard/Logs/Logs";

export default function LogList() {
  return (
    <>
      <div className="p-[2%]">
        <LogView />
      </div>
    </>
  );
}
